import template from './pop-up.html';
import controller from './pop-up.controller';
import './pop-up.scss';

let popUpComponent = {
  bindings: {},
  template,
  controller
};

export default popUpComponent;



// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up.component.js